<div class="background height">
  <div class="margin">
    <div class="content">
        <div class="options" id="containerHeaderPublic">
            <div fxLayout="row" fxLayoutGap="33px" fxLayoutAlign="start end" class="options">
              <img src="../../../../assets/img/novo-logo-branco.png" alt="logo ecossistema" style="cursor: pointer;" (click)="irParaHome()">
              <a (click)="verEcossistema()">O ECOSSISTEMA</a>
              <a routerLink="./catalogo-projetos">PROJETOS</a>
            </div>
            <app-button (click)="login()" [txt]="'ENTRAR'" [class]="'border-blue-filled'" [customStyle]="'border: 2px solid #FBFBFB !important; background-color: #FBFBFB !important; border-radius: 20px; color: #008DE0 !important'">
            </app-button>
        </div>
    </div>
  </div>
</div>